import { createBrowserRouter } from 'react-router-dom';

// project import
import { SimpleLayoutType } from 'types/config';
import SimpleLayout from 'layout/Simple';
import ErrorBoundary from './ErrorBoundary';
import { PageUrl } from 'const/page-url';

// ページは lazy ではなく静的に読み込んでいる。
//
// ビルド後に scripts/prerender.js が各ページを描画済みHTMLとして書き出しており、
// ブラウザはそのHTMLを hydrateRoot で引き継ぐ。lazy にしていると、引き継ぐ瞬間には
// まだチャンクが解決しておらず Suspense の fallback(Loader) が描画されるため、
// HTML側の本文と一致せずハイドレーションに失敗し、Reactがページ全体を描き直してしまう
// (プリレンダの意味がなくなり、表示が一瞬ちらつく)。
//
// ページ数が5つと少なく、セクションの大半を共有しているため、
// 分割をやめても初期バンドルの増加はわずかで済んでいる。
import PagesLanding from '../pages/landing';
import PrivacyPolicy from '../pages/privacyPolicy';
import AiDataTransfer from '../pages/aiDataTransfer';
import DocumentRequest from '../pages/documentRequest';
import Features from '../pages/features';
import Blog from '../pages/blog';
import BlogArticle from '../pages/blogArticle';
import BlogCategory from '../pages/blogCategory';

// ==============================|| ROUTING RENDER ||============================== //

const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <SimpleLayout layout={SimpleLayoutType.LANDING} />,
      errorElement: <ErrorBoundary />,
      children: [
        {
          index: true,
          element: <PagesLanding />
        },
        {
          path: PageUrl.PrivacyPolicy.url,
          element: <PrivacyPolicy />,
        },
        {
          path: PageUrl.AiDataTransfer.url,
          element: <AiDataTransfer />,
        },
        {
          path: PageUrl.DocumentRequest.url,
          element: <DocumentRequest />,
        },
        {
          path: PageUrl.Features.url,
          element: <Features />,
        },
        // お役立ち記事。一覧が /blog、記事本体が /blog/<slug>。
        // 記事ごとのルートは書かない(slug から src/const/blog の ARTICLES を引く)ため、
        // 記事を増やしてもここは変更不要。
        {
          path: PageUrl.Blog.url,
          element: <Blog />,
        },
        // カテゴリごとの一覧。/blog/:slug より先に置く必要はない(こちらは2階層で、
        // /blog/:slug は1階層にしかマッチしないため衝突しない)。
        // カテゴリの定義は src/const/blog/categories.ts にある。
        {
          path: `${PageUrl.Blog.url}/category/:categorySlug`,
          element: <BlogCategory />,
        },
        {
          path: `${PageUrl.Blog.url}/:slug`,
          element: <BlogArticle />,
        },
      ]
    },
  ],
  { basename: process.env.REACT_APP_BASE_NAME }
);

export default router;
